import { DialogContent } from "@mui/material";

const BasicDialogContent = (props) => {
  return (
    <DialogContent
      sx={{ paddingTop: 2, paddingBottom: 2, paddingLeft: 3, paddingRight: 3 }}
    >
      {props.children}
    </DialogContent>
  );
};

export default BasicDialogContent;
